import { useState, useEffect } from 'react';
import { Typography, Stack, Button } from '@mui/material';
import BrightstarLogo from '../assets/Brightstar-Lottery-Logo/Brightstar_logo_White_TM.png';
import SSO from '../assets/microsoft_sso_icon/ms-symbollockup_signin_light.svg';
import { signIn } from './authPopup';
import { useNavigate, useLocation } from 'react-router';
import { useAuth } from '../context/authContext';
import AuthModal from '../components/authModal';
import { useSearchParams } from 'react-router-dom';

const Login = () => {
  const { login, logout } = useAuth();
  const [urlParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [isSigningIn, setIsSigningIn] = useState(false);
  const [isAuthDialogOpen, setIsAuthDialogOpen] = useState(
    urlParams.has('email') &&
      (urlParams.has('inviteCode') || urlParams.has('resetCode')),
  );

  // Handle QR code logout requirement
  useEffect(() => {
    const isQRCodeRedirect = localStorage.getItem('qrCodeRedirect') === 'true';
    if (isQRCodeRedirect) {
      logout(); // Clear any existing authentication
      localStorage.removeItem('qrCodeRedirect');
    }
  }, [logout]);

  const handleSSOClick = async () => {
    if (isSigningIn) {
      return;
    }

    setIsSigningIn(true);
    try {
      const userDetails = await signIn(); // Authenticate and fetch user details
      if (userDetails) {
        login(userDetails, 'SSO'); // Update context with user details, including group names

        // Check if there's a redirect destination from protectedRoute
        const from = location.state?.from;
        let redirectPath = '/home';

        if (from) {
          // Remove qrCode parameter to prevent redirect loop in protectedRoute
          const params = new URLSearchParams(from.search);
          params.delete('qrCode');
          const newSearch = params.toString() ? `?${params.toString()}` : '';
          redirectPath = `${from.pathname}${newSearch}`;
        }

        navigate(redirectPath, { replace: true }); // Navigate to intended destination or home
      }
    } catch (error) {
      console.error('Error during SSO login:', error);
    } finally {
      setIsSigningIn(false);
    }
  };

  return (
    <div
      style={{
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 46, 229)',
        // backgroundImage:
        //   "linear-gradient(-45deg, rgba(247, 231, 229, 0.8), rgba(0, 46, 229, 0.8), rgba(247, 231, 229, 0.8), rgba(0, 46, 229, 0.8))",
        backgroundSize: '400% 400%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <style>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>

      <Stack
        sx={{
          alignItems: 'center',
          marginBottom: '20px',
        }}
      >
        <Typography
          variant='h1'
          sx={{
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <span
            style={{
              fontWeight: 'bold',
              color: 'var(--dust-white)',
              fontFamily: 'BrightstarSans-Regular',
            }}
          >
            ENGAGE
          </span>{' '}
        </Typography>
        <div style={{ display: 'flex' }}>
          <span
            style={{
              color: 'var(--dust-white)',
              fontSize: '12px',
              fontFamily: 'BrightstarSans-Regular',
              marginTop: '25px',
            }}
          >
            By
          </span>
          <img
            src={BrightstarLogo}
            alt='Brightstar Logo'
            style={{ height: '50px' }}
          />
        </div>
      </Stack>

      <Button
        onClick={handleSSOClick}
        disabled={isSigningIn}
        sx={{ textTransform: 'none', padding: 0, mt: 2 }}
      >
        <img
          src={SSO}
          alt='Sign In With Microsoft'
          style={{ height: '30px' }}
        />
      </Button>
      <Typography
        sx={{
          fontSize: '0.75rem',
          color: 'var(--dust-white)',
          marginTop: '15px',
          fontFamily: 'BrightstarSans-Regular',
        }}
      >
        Copyright ©​{new Date().getFullYear()} Brightstar Lottery. All Rights
        Reserved.
      </Typography>
      <AuthModal
        isDialogOpen={isAuthDialogOpen}
        setIsDialogOpen={setIsAuthDialogOpen}
        email={urlParams.get('email')}
        inviteCode={urlParams.get('inviteCode')}
        resetCode={urlParams.get('resetCode')}
      />
    </div>
  );
};

export default Login;
